export default __webpack_public_path__ + "static/media/conversations.b5f832d7.svg";